<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    会展城站<br>
站点介绍
会展城站位于宝安区海滨大道与和汇路交汇口以东，车站主体沿东西向布置，东接国展北站，20号线一期终点站。 会展城站色彩基调以北卡蓝色为主，为地下二层车站，地下一层为11米无柱设计站厅层，地下二层为站台层，站台形式为岛式站台。车站设置有4个出入口，周边为空港新区启动用地。<br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
机场北站	07:00	22:00	20号线	7分钟	9分钟-13分26秒<br>
会展城站	--	--	20号线	7分钟	9分钟-13分26秒<br><br>
运营时刻表(休息日)
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
机场北站	07:00	22:00	20号线	7分钟	9分钟-13分26秒<br>
会展城站	－	－	20号线	7分钟	9分钟-13分26秒<br><br>
运营时刻表(节假日)
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
机场北站	07:00	22:00	20号线	7分钟	9分钟-13分26秒<br>
会展城站	－	－	20号线	7分钟	9分钟-13分26秒<br><br>

站点出口信息<br><br>
A出入口:<br>
附近为工地，市政道路在建<br><br>
B出入口:<br>
附近为工地，市政道路在建<br><br>
C出入口:<br>
附近为工地，市政道路在建<br><br>
D出入口:<br>
附近为工地，市政道路在建<br>
公交换乘信息<br><br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "ershihaoxian",
          title: "20号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>
